import React, { Component } from 'react';
import ClipLoader from "react-spinners/ClipLoader";

export default class Header extends Component {
    render() {
        const modelDescription = this.props.modelDescription;
        const cfgLeadTime = this.props.cfgLeadTime;
        const cfgPrice = this.props.cfgPrice;
        const isUpdating = cfgLeadTime == "!!!" || cfgPrice == "!!!";//!!!можно разделить на вывод по очереди
        const showPricenTime = this.props.showPricenTime;

        if (!showPricenTime) {
            return (
                <div className="heading">
                    Модель:&nbsp;
                    <div className="headingModel">
                        {modelDescription}
                    </div>
                </div>
            );
        }
        else if ((cfgLeadTime != undefined && cfgLeadTime != "" || cfgPrice != undefined && cfgPrice != "")
            && !isUpdating) {
            return (
                <div className="heading">
                    Модель:&nbsp;
                    <div className="headingModel">
                        {modelDescription}
                    </div>
                    &nbsp;|&nbsp;Срок изготовления:&nbsp;
                    <div className="headingModel">
                        {cfgLeadTime}
                    </div>
                    &nbsp;|&nbsp;Стоимость:&nbsp;
                    <div className="headingModel">
                        {cfgPrice} ₽
                    </div>
                </div>
            );
        }
        else {
            return (
                <div className="heading">
                    Модель:&nbsp;
                    <div className="headingModel">
                        {modelDescription}
                    </div>
                    &nbsp;|&nbsp;
                    {isUpdating ?
                        <div style={isUpdating == true ? { display: "block" } : { display: "none" }}>
                            <ClipLoader

                                loading={isUpdating}
                                //cssOverride={override}
                                size="12px"
                                speedMultiplier="0.7"
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            />
                        </div>
                        : 'Срок изготовления и стоимость не определены'}
                </div>
            );
        }
    }
}
